import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'currency_display_order';

@Injectable({
  providedIn: 'root'
})
export class CurrencyOrderService {
  private orderSubject = new BehaviorSubject<string[]>(this.loadOrder());

  order$ = this.orderSubject.asObservable();

  private loadOrder(): string[] {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  }

  getOrder(): string[] {
    return this.orderSubject.value;
  }

  saveOrder(order: string[]): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(order));
    this.orderSubject.next([...order]);
  }

  /**
   * Given a list of currency names (from the API), return them sorted
   * according to the saved order. Unknown currencies are appended at the end.
   */
  applyOrder(currencies: string[]): string[] {
    const saved = this.getOrder();
    if (saved.length === 0) return currencies;

    const inOrder = saved.filter(c => currencies.includes(c));
    const rest = currencies.filter(c => !saved.includes(c));
    return [...inOrder, ...rest];
  }

  clearOrder(): void {
    localStorage.removeItem(STORAGE_KEY);
    this.orderSubject.next([]);
  }
}